<template>
<m-pageframe
    title="Built In Rate Cards"
>
<v-container>

    <m-edit-select-rate-card
        v-model="rate_card_id"
        v-on:input="update"
    />

    <v-data-table
        :headers="headers"
        :items="lines"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"

        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
            }"
    >

        <template v-slot:item.fee_setup_milli_cents="{ item }">
            {{prettyPrintPrice(item.fee_setup_milli_cents)}}
        </template>

        <template v-slot:item.fee_milli_cents="{ item }">
            {{prettyPrintPrice(item.fee_milli_cents)}}
        </template>

        <template v-slot:item.count_included="{ item }">
            {{prettyPrintCount(item.count_included)}}
        </template>

        <template v-slot:item.fee_milli_percent="{ item }">
            {{prettyPrintMillipercent(item.fee_milli_percent)}}
        </template>

     </v-data-table>


</v-container>
</m-pageframe>
</template>

<script>

const Millicents = require('@/js/millicents.js');

export default {
    data() {
        return {
            rate_card_id: null,
            lines: [],

            headers: [
                { 'text' : 'Item', 'value' : 'line_type' },
                { 'text' : 'Setup Fee', 'value' : 'fee_setup_milli_cents' },
                { 'text' : '# Included', 'value' : 'count_included' },
                { 'text' : 'Fee', 'value' : 'fee_milli_cents' },
                { 'text' : 'Percentage', 'value' : 'fee_milli_percent' },
            ],
        }
    },

    methods: {
        update() {
            this.$rc.showSpinner();

            let search = {
                'rate_card_id' : this.rate_card_id,
            };
            
            this.$rc.listBuiltInRateCardLines(
                search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.lines = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.lines = [];
                },
            );
        },

        prettyPrintPrice(mc)
        {
            if ( mc == null || mc == 0 )
                return '';

            return Millicents.prettyPrint(mc);
        },

        prettyPrintMillipercent(mc)
        {
            if ( mc == null || mc == 0 )
                return '';

            return Millicents.prettyPrintMillipercent(mc);
        },

        prettyPrintCount(count)
        {
            if ( count == null || count == 0 )
                return '';
            
            return count.toLocaleString();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>